<template>
  <v-container>
    <v-divider></v-divider>
    <div class="references caption">
      <v-col cols="12">
        <strong>References</strong>
        <p>
          1. Nishitani, S., Kasaba, R., Hiraoka, D., Shimada, K., Fujisawa, TX., Okazawa, H., Tomoda, A. (2022). Epigenetic clock deceleration and maternal reproductive efforts: Associations with increasing gray matter volume of the precuneus,
          <strong>
            <i>Frontiers in Genetics</i>
          </strong>, 13:803584.
          <a
            href="https://www.frontiersin.org/articles/10.3389/fgene.2022.803584/full"
            target="_blank"
            rel="noopener noreferrer"
          >doi.org/10.3389/fgene.2022.803584</a>.
        </p>
        <p>
          2. Cheong, Y., Nishitani, S., Yu, J., Habata, K., Kamiya, T., Shiotsu, D., Omori, I.M., Okazawa, H., Tomoda, A., Kosaka, H., Jung, M. (2022). Associations of epigenetic age and its acceleration on the human brain,
          <strong>
            <i>Cerebral Cortex</i>
          </strong>, bhac043.
        <a
            href="https://academic.oup.com/cercor/advance-article-abstract/doi/10.1093/cercor/bhac043/6535012"
            target="_blank"
            rel="noopener noreferrer"
          >doi: 10.1093/cercor/bhac043</a>.
        </p>
        <p>
          3. Fujisawa, T.X., Nishitani, S., Makita, K., Yao, A., Takiguchi, S., Hamamura, S., Shimada, K., Okazawa, H., Matsuzaki, H., Tomoda, A. (2022). Association of epigenetic differences identified in monozygotic twins discordant for attention-deficit hyperactivity disorder with brain structures,
          <strong>
            <i>Frontiers in Neuroscience</i>
          </strong>, 15:799761.
        <a
            href="https://www.frontiersin.org/articles/10.3389/fnins.2021.799761/full"
            target="_blank"
            rel="noopener noreferrer"
          >doi.org/10.3389/fnins.2021.799761</a>.
        </p>
        <p>
          4. Nishitani, S., Fujisawa, T.X., Hiraoka, D., Makita, K., Takiguchi, S., Hamamura, S., Yao, A., Shimada, K., Smith, A.K., & Tomoda, A. (2021). A multi-modal MRI analysis of brain structure and function in relation to OXT methylation in maltreated children and adolescents,
          <strong>
            <i>Translational Psychiatry</i>
          </strong>, 11(1):589.
        <a
            href="https://www.nature.com/articles/s41398-021-01714-y"
            target="_blank"
            rel="noopener noreferrer"
          >doi: 10.1038/s41398-021-01714-y</a>.
        </p>
        <p>
          5. Andari, E., Nishitani, S., Kaundinya, G., Caceres, G., Ousley, O., Morrier, M., Smith, A.K., Cubells, J.F., & Young, L.J. (2020). Epigenetic modification of the oxytocin receptor gene: implications for autism symptom severity and brain functional connectivity,
          <strong>
            <i>Neuropsychopharmacology</i>
          </strong>, 45(7):1150-1158.
        <a
            href="https://www.nature.com/articles/s41386-020-0610-6"
            target="_blank"
            rel="noopener noreferrer"
          >doi: 10.1038/s41386-020-0610-6</a>.
        </p>
        <p>
          6. Fujisawa, T.X§., Nishitani, S§ (§: equally contributed)., Takiguchi, S., Shimada, K., Smith, A.K., & Tomoda, A. (2019). Oxytocin receptor DNA methylation and alterations of brain volumes in maltreated children and adolescents,
          <strong>
            <i>Neuropsychopharmacology</i>
          </strong>, 44: 2045-2053.
        <a
            href="https://www.nature.com/articles/s41386-019-0414-8"
            target="_blank"
            rel="noopener noreferrer"
          >doi: 10.1038/s41386-019-0414-8</a>.
        </p>
        <p>
          7. Chen, X., Nishitani, S., Haroon, E., Smith, A.K., & Rilling, J.K. (2019). OXTR methylation modulates exogenous oxytocin effects on human brain activity during social interaction,
          <strong>
            <i>Genes, Brain and Behavior</i>
          </strong>, e12555.
        <a
            href="https://onlinelibrary.wiley.com/doi/full/10.1111/gbb.12555"
            target="_blank"
            rel="noopener noreferrer"
          >doi: 10.1111/gbb.12555</a>.
        </p>
        <p>
          8. Haas, B.W., Filkowski, M.M., Cochran, R.N., Denison, L., Ishak, A., Nishitani, S., & Smith, A.K. (2016). Epigenetic modification of OXT and human sociability.
          <strong>
            <i>PNAS</i>
          </strong>, 113(27), E3816-23.
        <a
            href="https://www.pnas.org/doi/10.1073/pnas.1602809113"
            target="_blank"
            rel="noopener noreferrer"
          >doi: 10.1073/pnas.1602809113</a>.
        </p>
        <p>
          9. Whitwell, J.L. (2009). Voxel-Based Morphometry: An Automated Technique for Assessing Structural Changes in the Brain,
          <strong>
            <i>Journal of Neuroscience</i>
          </strong>, 29(31), 9661-64.
        <a
            href="https://doi.org/10.1523/JNEUROSCI.2160-09.2009"
            target="_blank"
            rel="noopener noreferrer"
          >doi.org/10.1523/JNEUROSCI.2160-09.2009</a>.
        </p>
        <p>
          10. Nishitani, S. (2022). Chapter 20: Capturing the Epigenome: Differences Among Blood, Saliva, and Brain Samples.
          <strong>
            <i>Epigenetics of Stress and Stress Disorders (Editor: Nagy Youssef, book) </i>
          </strong>, Academic Press, ISBN: 9780128230398.
        <a
            href="https://www.elsevier.com/books/epigenetics-of-stress-and-stress-disorders/youssef/978-0-12-823039-8"
            target="_blank"
            rel="noopener noreferrer"
          >https://www.elsevier.com/books/epigenetics-of-stress-and-stress-disorders/youssef/978-0-12-823039-8</a>
        </p>
        <p>
          11. AMAZE-CpG (
        <a
            href="https://sites.google.com/view/snishit/home/amaze-cpg?authuser=0"
            target="_blank"
            rel="noopener noreferrer"
          >https://sites.google.com/view/snishit/home/amaze-cpg?authuser=0</a> )
        </p>
        <p>
          12. Braun, P. R., Han, S., Hing, B., Nagahama, Y., Gaul, L. N., Heinzman, J. T., Grossbach, A. J., Close, L., Dlouhy, B. J., Howard, M. A., Kawasaki, H., Potash, J. B., & Shinozaki, G. (2019). Genome-wide DNA methylation comparison between live human brain and peripheral tissues within individuals.
          <strong>
            <i>Translational Psychiatry</i>
          </strong>, 9(1), 47.
        <a
            href="https://doi.org/10.1038/s41398-019-0376-y"
            target="_blank"
            rel="noopener noreferrer"
          >https://doi.org/10.1038/s41398-019-0376-y</a>.
        </p>
        <p>
          13. Alexandre, A., Fabian, P., Michael, E., Philippe, G., Andreas, M., Jean, K., Alexandre, G., Bertrand, T., & Gael V. (2014). Machine learning for neuroimaging with scikit-learn,
          <strong>
            <i>Frontiers in Neuroinformatics</i>
          </strong>,
        <a
            href="https://www.frontiersin.org/articles/10.3389/fninf.2014.00014/full"
            target="_blank"
            rel="noopener noreferrer"
          >doi.org/10.3389/fninf.2014.00014</a>.
        </p>
      </v-col>
    </div>

    <v-footer class="footerInfo" style="display: block;">
      {{ developer }}
      <p class="mb-0">Google Scholar:
        <a
          href="https://scholar.google.com/citations?hl=en&user=GiaWnTcAAAAJ&view_op=list_works"
          target="_blank"
          rel="noopener noreferrer"
        >https://scholar.google.com/citations?hl=en&user=GiaWnTcAAAAJ&view_op=list_works</a>
      </p>
      <p class="mb-0">Research Gate:
        <a
          href="https://www.researchgate.net/profile/Shota-Nishitani"
          target="_blank"
          rel="noopener noreferrer"
        >https://www.researchgate.net/profile/Shota-Nishitani</a>
      </p>
      <p class="mb-0">Website:
        <a
          href="https://sites.google.com/view/snishit/home"
          target="_blank"
          rel="noopener noreferrer"
        >https://sites.google.com/view/snishit/home</a>
      </p>
    </v-footer>
  </v-container>
</template>
<script>
export default {
  name: 'ReferencesFooter',
  data () {
    return {
      developer: `
Shota Nishitani, Ph.D.
Associate Professor / Lecturer
Research Center for Child Mental Development, University of Fukui, Japan.
Division of Developmental Higher Brain Functions, United Graduate School of Child Development, Osaka University, Kanazawa University, Hamamatsu University School of Medicine, Chiba University, and University of Fukui, Osaka, Japan.
ORCID: 0000-0002-6234-295X`
    }
  }
}
</script>

<style>
div.references p {
  margin: 0.35em 0px;
}
.footerInfo {
  white-space: pre-wrap;
}
</style>
